export const LayoutType = {
  Default: 'default',
  Login: 'login',
}
